<template>
  <aside v-if="contest" class="contest-entry-form-aside">
    <img
      class="contest-image"
      :src="contestImageUrl"
      :alt="contest.contest"
      width="236"
      height="124"
      loading="lazy"
    />
    <p class="contest-title">{{ contest.contest }}</p>
  </aside>
</template>

<script lang="ts" setup>
import { computed, defineProps } from "vue";
import { NolaPfMicroCmsContest } from "@/lib/models/nolaPfContest";
import { optimizeImage } from "@/lib/utils/url";

const props = defineProps<{
  contest: NolaPfMicroCmsContest | null;
}>();

const contestImageUrl = computed(() => {
  const url = props.contest?.image.url;
  if (!url) return "";
  return optimizeImage(url);
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.contest-entry-form-aside {
  flex-shrink: 0;
  width: 236px;
}

.contest-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: var(--radius-sm);
  object-fit: cover;
}

.contest-title {
  margin: 8px 0 0;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-default);
}

@include mq("sp") {
  .contest-entry-form-aside {
    display: none;
  }
}
</style>
